import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { StyledText, StyledTextIcon } from './writeup-modal.styles';
export const AddWriteupConfirmation = () => {
  const checkMarkIcon = <StyledTextIcon icon={faCheck} />;
  return <StyledText data-sentry-element="StyledText" data-sentry-component="AddWriteupConfirmation" data-sentry-source-file="add-writeup-confirmation.tsx">
      {checkMarkIcon} Hooray! Your write-up has been submitted and is awaiting review by the room creator.
    </StyledText>;
};